var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"app-layout"},[_c('el-aside',{class:{collapse:_vm.menuData.collapse}},[_c('Menu')],1),_vm._v(" "),_c('el-main',[_c('header',[_c('AppHeader')],1),_vm._v(" "),_c('main',[_c('transition',{staticClass:"app-main",attrs:{"name":"fade"}},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57543c3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/AppLayout.vue
// module id = null
// module chunks = 